import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import NotFoundPage from './pages/NotFoundPage';
import AboutPage from './pages/AboutPage';
import MeetUsPage from './pages/MeetUsPage';
import CareersPage from './pages/CareersPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';
import CalculusPage from './pages/CalculusPage';
import CovenantPage from './pages/CovenantPage';
import PhilosophyPage from './pages/PhilosophyPage';
import AstrocyteMetalayerPage from './pages/AstrocyteMetalayerPage';
import ManifestoPage from './pages/ManifestoPage';
import FundUsPage from './pages/FundUsPage';
import DragonBricksPage from './pages/DragonBricksPage';
import RadicalAuditabilityPage from './pages/RadicalAuditabilityPage';
import RecognitionVsExperiencePage from './pages/RecognitionVsExperiencePage';
import GlassBoxPage from './pages/GlassBoxPage';
import TheIntegralPage from './pages/TheIntegralPage';
import TheReadableMindPage from './pages/TheReadableMindPage';
import TheThreeQuestionsPage from './pages/TheThreeQuestionsPage';
import VolatilityIsSignalPage from './pages/VolatilityIsSignalPage';
import TheProofPage from './pages/TheProofPage';
import ArchitectureOfAccountabilityPage from './pages/ArchitectureOfAccountabilityPage';
import ChemicalTrailPage from './pages/ChemicalTrailPage';
import TheQuestionPage from './pages/TheQuestionPage';
import PatentsPage from './pages/PatentsPage';
import NLMDemoPage from './pages/NLMDemoPage';
import NLMLogPage from './pages/NLMLogPage';
import CalculusOfEmotionsPage from './pages/CalculusOfEmotionsPage';
import PrivateAIPage from './pages/PrivateAIPage';
import PricingPage from './pages/PricingPage';
import TheObserverPage from './pages/TheObserverPage';
import DischargeDemoPage from './pages/DischargeDemoPage';
import LivingIntegralPage from './pages/LivingIntegralPage';
import CalculusOfMercyPage from './pages/CalculusOfMercyPage';
import CalculusOfConversationPage from './pages/CalculusOfConversationPage';
import CalculusOfHarmPage from './pages/CalculusOfHarmPage';
import CalculusOfCarePage from './pages/CalculusOfCarePage';
import CalculusOfCompassionPage from './pages/CalculusOfCompassionPage';
import CalculusOfCuriosityPage from './pages/CalculusOfCuriosityPage';
import CalculusOfResiliencePage from './pages/CalculusOfResiliencePage';
import CalculusOfEndurancePage from './pages/CalculusOfEndurancePage';
import HumanSideOfTelecomPage from './pages/HumanSideOfTelecomPage';
import ChemistryOfLeadershipPage from './pages/ChemistryOfLeadershipPage';
import GnulPage from './pages/GnulPage';
import GnulChapter1Page from './pages/GnulChapter1Page';
import GnulChapter2Page from './pages/GnulChapter2Page';
import GnulChapter3Page from './pages/GnulChapter3Page';
import GnulChapter4Page from './pages/GnulChapter4Page';
import GnulChapter5Page from './pages/GnulChapter5Page';
import GnulChapter6Page from './pages/GnulChapter6Page';
import GnulChapter7Page from './pages/GnulChapter7Page';
import GnulChapter8Page from './pages/GnulChapter8Page';
import CalculusOfProgressPage from './pages/CalculusOfProgressPage';
import ChemistryOfProgressPage from './pages/ChemistryOfProgressPage';
import WillingnessToPayPage from './pages/WillingnessToPayPage';
// REMOVED: Alianza content removed April 1, 2026
import CalculusOfSentimentPage from './pages/CalculusOfSentimentPage';
import CalculusOfAlignmentPage from './pages/CalculusOfAlignmentPage';
import SyntheticProfilesPage from './pages/SyntheticProfilesPage';
import ChemistryOfUnsolvableProblemsPage from './pages/ChemistryOfUnsolvableProblemsPage';
import ScylaPage from './pages/ScylaPage';
import ScylaConstructionPage from './pages/ScylaConstructionPage';
import DocumentsPage from './pages/DocumentsPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function RevealObserver() {
  const { pathname } = useLocation();
  useEffect(() => {
    const timeout = setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

      return () => observer.disconnect();
    }, 50);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RevealObserver />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/meet-us" element={<MeetUsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/philosophy" element={<PhilosophyPage />} />
          <Route path="/philosophy/the-calculus-of-meaning" element={<CalculusPage />} />
          <Route path="/philosophy/the-astrocyte-metalayer" element={<AstrocyteMetalayerPage />} />
          <Route path="/philosophy/the-human-is-the-loop" element={<ManifestoPage />} />
          <Route path="/philosophy/when-the-dragon-picks-up-the-bricks" element={<DragonBricksPage />} />
          <Route path="/philosophy/radical-auditability" element={<RadicalAuditabilityPage />} />
          <Route path="/philosophy/recognition-vs-experience" element={<RecognitionVsExperiencePage />} />
          <Route path="/philosophy/the-glass-box" element={<GlassBoxPage />} />
          <Route path="/philosophy/the-integral" element={<TheIntegralPage />} />
          <Route path="/philosophy/the-readable-mind" element={<TheReadableMindPage />} />
          <Route path="/philosophy/the-three-questions" element={<TheThreeQuestionsPage />} />
          <Route path="/philosophy/volatility-is-the-signal" element={<VolatilityIsSignalPage />} />
          <Route path="/philosophy/the-proof" element={<TheProofPage />} />
          <Route path="/philosophy/architecture-of-accountability" element={<ArchitectureOfAccountabilityPage />} />
          <Route path="/philosophy/chemical-trail-of-auditability" element={<ChemicalTrailPage />} />
          <Route path="/philosophy/the-observer" element={<TheObserverPage />} />
          <Route path="/philosophy/the-living-integral" element={<LivingIntegralPage />} />
          <Route path="/philosophy/the-calculus-of-emotions" element={<CalculusOfEmotionsPage />} />
          <Route path="/philosophy/the-calculus-of-mercy" element={<CalculusOfMercyPage />} />
          <Route path="/philosophy/the-calculus-of-a-conversation" element={<CalculusOfConversationPage />} />
          <Route path="/philosophy/the-calculus-of-a-conversation.html" element={<CalculusOfConversationPage />} />
          <Route path="/philosophy/the-calculus-of-harm" element={<CalculusOfHarmPage />} />
          <Route path="/philosophy/the-calculus-of-harm.html" element={<CalculusOfHarmPage />} />
          <Route path="/philosophy/the-calculus-of-care" element={<CalculusOfCarePage />} />
          <Route path="/philosophy/the-calculus-of-care.html" element={<CalculusOfCarePage />} />
          <Route path="/philosophy/the-calculus-of-compassion" element={<CalculusOfCompassionPage />} />
          <Route path="/philosophy/the-calculus-of-compassion.html" element={<CalculusOfCompassionPage />} />
          <Route path="/philosophy/the-calculus-of-curiosity" element={<CalculusOfCuriosityPage />} />
          <Route path="/philosophy/the-calculus-of-curiosity.html" element={<CalculusOfCuriosityPage />} />
          <Route path="/philosophy/the-chemistry-of-resilience" element={<CalculusOfResiliencePage />} />
          <Route path="/philosophy/the-chemistry-of-resilience.html" element={<CalculusOfResiliencePage />} />
          <Route path="/philosophy/the-calculus-of-endurance" element={<CalculusOfEndurancePage />} />
          <Route path="/philosophy/the-calculus-of-endurance.html" element={<CalculusOfEndurancePage />} />
          <Route path="/philosophy/the-human-side-of-telecom" element={<HumanSideOfTelecomPage />} />
          <Route path="/philosophy/the-human-side-of-telecom.html" element={<HumanSideOfTelecomPage />} />
          <Route path="/philosophy/the-chemistry-of-leadership" element={<ChemistryOfLeadershipPage />} />
          <Route path="/philosophy/the-chemistry-of-leadership.html" element={<ChemistryOfLeadershipPage />} />
          <Route path="/philosophy/the-calculus-of-progress" element={<CalculusOfProgressPage />} />
          <Route path="/philosophy/the-calculus-of-progress.html" element={<CalculusOfProgressPage />} />
          <Route path="/philosophy/the-chemistry-of-progress" element={<ChemistryOfProgressPage />} />
          <Route path="/philosophy/the-chemistry-of-progress.html" element={<ChemistryOfProgressPage />} />
          <Route path="/philosophy/the-willingness-to-pay" element={<WillingnessToPayPage />} />
          {/* REMOVED: Alianza content removed April 1, 2026 */}
          <Route path="/philosophy/the-calculus-of-alignment" element={<CalculusOfAlignmentPage />} />
          <Route path="/philosophy/the-chemistry-of-unsolvable-problems" element={<ChemistryOfUnsolvableProblemsPage />} />
          <Route path="/philosophy/the-calculus-of-alignment.html" element={<CalculusOfAlignmentPage />} />
          <Route path="/philosophy/the-calculus-of-sentiment-analysis" element={<CalculusOfSentimentPage />} />
          <Route path="/philosophy/the-calculus-of-sentiment-analysis.html" element={<CalculusOfSentimentPage />} />
          <Route path="/philosophy/the-calculus-of-emotions.html" element={<CalculusOfEmotionsPage />} />
          <Route path="/the-question" element={<TheQuestionPage />} />
          <Route path="/covenant" element={<CovenantPage />} />
          <Route path="/fund-us" element={<FundUsPage />} />
          <Route path="/patents" element={<PatentsPage />} />
          <Route path="/nlm-demo" element={<NLMDemoPage />} />
          <Route path="/nlm-log" element={<NLMLogPage />} />
          <Route path="/private-ai" element={<PrivateAIPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/discharge-demo" element={<DischargeDemoPage />} />
          <Route path="/gnul" element={<GnulPage />} />
          <Route path="/gnul/chapter-1" element={<GnulChapter1Page />} />
          <Route path="/gnul/chapter-2" element={<GnulChapter2Page />} />
          <Route path="/gnul/chapter-3" element={<GnulChapter3Page />} />
          <Route path="/gnul/chapter-4" element={<GnulChapter4Page />} />
          <Route path="/gnul/chapter-5" element={<GnulChapter5Page />} />
          <Route path="/gnul/chapter-6" element={<GnulChapter6Page />} />
          <Route path="/gnul/chapter-7" element={<GnulChapter7Page />} />
          <Route path="/gnul/chapter-8" element={<GnulChapter8Page />} />
          <Route path="/discharge-demo/callback" element={<DischargeDemoPage />} />
          <Route path="/synthetic-profiles" element={<SyntheticProfilesPage />} />
          <Route path="/neupharm" element={<SyntheticProfilesPage />} />
          <Route path="/scyla" element={<ScylaPage />} />
          <Route path="/scyla_construction" element={<ScylaConstructionPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
